import { BrowserRouter as Router } from "react-router-dom";
import { FunctionComponent, useEffect, useMemo, useState } from "react";
import getRoutes from "./routes";
import AppLayout from "./components/layout/Layout";
import { getUsersAndPermissions } from "./utils/helpers/data/userAndPermissions";
import { User } from "./utils/helpers/types";
import UserContext from "./context/user-context";

const AppContent: FunctionComponent = () => {
  const [user, setUser] = useState<User | null>(null);
  const [waitingMessage, setWaitingMessage] = useState("Loading. . .");

  useEffect(() => {
    const fetchUserAndPermissions = async () => {
      const response = await getUsersAndPermissions();
      if (response.error) {
        setWaitingMessage(
          "Unable to load application. Please contact your administrator"
        );
        return;
      }
      console.log({ userData: response.data });
      setUser(response.data);
    };

    fetchUserAndPermissions();
  }, []);

  const userContextValue = useMemo(() => ({ user, setUser }), [user]);

  return user ? (
    <UserContext.Provider value={userContextValue}>
      <AppLayout>{getRoutes(user)}</AppLayout>
    </UserContext.Provider>
  ) : (
    <div>{waitingMessage}</div>
  );
};

const App: FunctionComponent = () => {
  return (
    <Router>
      <AppContent />
    </Router>
  );
};

export default App;
